/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
import { Box, Divider, Typography, makeStyles } from '@material-ui/core';
import AvailableCourierItem, {
  IAvailableCourierItemProps
} from '../components-molecules/AvailableCourierItem';
import { colours } from '../constants/theme';

interface IOnChange {
  ids: string[];
  isPremium?: boolean;
  maxPriceQuoteId?: string | null;
}

interface ICollectionOrderCourierSelectionProps {
  couriers?: {
    AvailableCouriers?: IAvailableCourierItemProps[];
    Premium?: IAvailableCourierItemProps;
  };
  onChange: (body: IOnChange) => void;
  hasError: boolean;
  placeOrderLoading: boolean;
  onSubmit: (id: string) => void;
  maxPriceQuoteId?: string;
  setMaxPriceQuoteId: (id: string | null) => void;
}

const useStyles = makeStyles(() => ({
  description: {
    marginTop: 8
  }
}));

export default function CollectionOrderCourierSelection(
  props: ICollectionOrderCourierSelectionProps
) {
  const {
    couriers,
    onChange,
    hasError,
    placeOrderLoading,
    onSubmit,
    maxPriceQuoteId,
    setMaxPriceQuoteId
  } = props;
  const classes = useStyles();

  const onSetMaxPrice = (id: string) => {
    setMaxPriceQuoteId(id);
    // Update selected quote IDs to include all quotes at or below the max price
    const maxPrice = couriers?.AvailableCouriers?.find(c => c.Id === id)?.Price?.Min?.Total;
    if (maxPrice) {
      const belowMaxPriceIds = couriers?.AvailableCouriers
        ?.filter(c => c.Price.Min.Total <= maxPrice)
        ?.map(c => c.Id) || [];
      onChange({ ids: belowMaxPriceIds, maxPriceQuoteId: id });
    }
  };

  const onUnsetMaxPrice = (id: string) => {
    setMaxPriceQuoteId(null);
    onChange({ ids: [], maxPriceQuoteId: null });
  };

  const onPremierAccept = (id: string) => {
    onSubmit(id);
  };

  function renderCouriers() {
    if (!couriers?.AvailableCouriers) {
      return null;
    }
    return (
      <>
        <Typography variant="h6" color="primary">
          Available couriers
        </Typography>
        <Typography variant="body2" className={classes.description}>
          Review the couriers below and set the max price you are willing to pay to delivery your items.
          Setting a higher max price will maximise the chance of a speedy assignment, but we will endeavour to get you the cheapest options first.
        </Typography>

        {couriers.AvailableCouriers?.map((c, i) => (
          <Box key={c.Name} style={{ marginTop: i === 0 ? 16 : 0 }}>
            <AvailableCourierItem
              {...c}
              isMaxPrice={maxPriceQuoteId === c.Id}
              isBelowMaxPrice={maxPriceQuoteId ?
                (couriers?.AvailableCouriers?.find(mp => mp.Id === maxPriceQuoteId)?.Price?.Min?.Total || 0) >= (c.Price?.Min?.Total || 0)
                : false
              }
              onSetMaxPrice={onSetMaxPrice}
              onUnsetMaxPrice={onUnsetMaxPrice}
              hasError={hasError}
              disabled={placeOrderLoading}
            />
            {couriers.AvailableCouriers?.length !== i + 1 && (
              <Divider style={{ margin: '16px 0', background: colours.dark08 }} />
            )}
          </Box>
        ))}
      </>
    );
  }

  function renderPremierService() {
    if (!couriers?.Premium) {
      return null;
    }
    return (
      <Box mt={2}>
        <Typography variant="h6" color="primary">
          Concierge Service
        </Typography>
        <Typography variant="body2" className={classes.description}>
          Leave it to us! Our Concierge team selects the best courier to meet your needs, ensuring a timely delivery
        </Typography>

        <Box mt={2}>
          <AvailableCourierItem
            {...couriers?.Premium}
            hasError={hasError}
            isPremier
            onPremierAccept={onPremierAccept}
            disabled={placeOrderLoading}
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box mt={2}>
      {renderCouriers()}
      {renderPremierService()}
    </Box>
  );
}
